module.exports = __webpack_public_path__ + "static/img/reqular_mail.9f70f9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/reqular_mail.png
// module id = +s+W
// module chunks = 0